import { fg } from '@atlaskit/platform-feature-flags/fg';

export const isHideNavMenusEnabled = (): boolean => fg('help_hubs_hide_nav_menus');

/** Which navbar menus the admin has hidden from the Pages panel. */
export const getHiddenNavMenus = (
	hiddenMenus: ReadonlyArray<string> | null | undefined,
): { isPortalsMenuHidden: boolean; isTopicsMenuHidden: boolean } => {
	const hidden = isHideNavMenusEnabled() ? (hiddenMenus ?? []) : [];

	return {
		isPortalsMenuHidden: hidden.includes('PORTALS'),
		isTopicsMenuHidden: hidden.includes('TOPICS'),
	};
};
